export default __webpack_public_path__ + "static/home-hero-31309aa8e77b7849bb994cd2b13a6219.svg";